module.exports = __webpack_public_path__ + "static/media/Background-medium.d4c51a58.png";